import { MapPin } from "lucide-react";

/**
 * Einsatzgebiete + regional optimierte SEO-Texte.
 * Reine Content-Sektion ohne Tracking/Lead-Logik.
 */
const AREAS = [
  "Großkrotzenburg",
  "Hanau",
  "Aschaffenburg",
  "Hainburg",
  "Seligenstadt",
  "Kahl am Main",
  "Alzenau",
  "Maintal",
  "Rodgau",
];

const ServiceAreas = () => {
  return (
    <section
      className="py-16 sm:py-20 bg-gradient-to-b from-white to-[#faf8f5]"
      data-testid="service-areas-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#f5e9d6] text-[#4A331D] text-xs font-semibold tracking-wide uppercase mb-3">
            <MapPin className="w-3.5 h-3.5" />
            Regional & zuverlässig
          </div>
          <h2
            className="text-3xl sm:text-4xl font-bold text-[#4A331D] mb-3"
            style={{ fontFamily: "Work Sans, sans-serif" }}
            data-testid="service-areas-heading"
          >
            Unsere Einsatzgebiete
          </h2>
          <p className="text-base text-gray-700 max-w-3xl mx-auto">
            BEKAJ BAU ist in Großkrotzenburg ansässig und arbeitet im gesamten Rhein-Main-Gebiet — schwerpunktmäßig rund um Hanau und Aschaffenburg.
          </p>
        </div>

        {/* Areas-Grid */}
        <ul
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-12"
          data-testid="service-areas-list"
        >
          {AREAS.map((city) => (
            <li
              key={city}
              className="flex items-center gap-2 bg-white border border-[#e8dfd4] rounded-lg px-4 py-3 shadow-sm hover:shadow-md hover:border-[#D4AA6A] transition"
              data-testid={`service-area-${city.toLowerCase().replace(/\s+/g, '-').replace(/ä/g,'ae')}`}
            >
              <MapPin className="w-4 h-4 text-[#D4AA6A] flex-shrink-0" />
              <span className="text-sm font-medium text-[#4A331D]">{city}</span>
            </li>
          ))}
        </ul>

        {/* SEO-relevante Fließtexte (natürlich formuliert) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          <div className="bg-white border border-[#e8dfd4] rounded-xl p-5 shadow-sm">
            <h3 className="font-bold text-[#4A331D] mb-2">Innenausbau Hanau &amp; Region</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              Vom Trockenbau über Maler- und Fliesenarbeiten bis hin zum kompletten Innenausbau —
              wir setzen Ihr Projekt in Hanau, Aschaffenburg und Umgebung sauber und termingerecht um.
            </p>
          </div>
          <div className="bg-white border border-[#e8dfd4] rounded-xl p-5 shadow-sm">
            <h3 className="font-bold text-[#4A331D] mb-2">Renovierung Hanau &amp; Aschaffenburg</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              Ob Wohnung, Einfamilienhaus oder Gewerbeobjekt: Wir renovieren Bestandsimmobilien
              gründlich, vom kleinen Auffrischen bis zur Komplettrenovierung mit Maler- und Bodenarbeiten.
            </p>
          </div>
          <div className="bg-white border border-[#e8dfd4] rounded-xl p-5 shadow-sm">
            <h3 className="font-bold text-[#4A331D] mb-2">Haus renovieren oder sanieren lassen</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              Sie möchten Ihr Haus renovieren oder sanieren lassen? Wir beraten Sie persönlich,
              prüfen den Aufwand vor Ort und liefern eine ehrliche Einschätzung — ohne Verkaufsdruck.
            </p>
          </div>
          <div className="bg-white border border-[#e8dfd4] rounded-xl p-5 shadow-sm">
            <h3 className="font-bold text-[#4A331D] mb-2">Fassadenarbeiten &amp; Bodenbeschichtungen</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              Fassadensanierung, Wärmedämmung, neuer Anstrich oder hochwertige Bodenbeschichtungen
              für Keller, Garage und Gewerbeflächen — alles aus einer Hand in der Region Hanau / Aschaffenburg.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
